<div class="attribute-card" *ngFor="let customField of filtered()">
  <profile-custom-field-editor
    [customFieldValues]="getCustomFieldValueByTypeId(customField.id)"
    [customField]="customField"
    [id]="customField.id"
  ></profile-custom-field-editor>
</div>
